<template>
  <div class="flex items-center border-b border-[#999]/25">
    <div class="relative flex w-full items-center gap-16">
      <button
        v-for="(tab, index) in tabs"
        :key="tab.value"
        ref="tabRefs"
        :class="[
          'max-w-1/3 truncate pb-4 text-2xl leading-9 transition-colors ...',
          modelValue === tab.value ? 'font-bold text-white' : 'text-light hover:text-white'
        ]"
        @click="handleTabClick(tab.value, index)"
      >
        {{ tab.label }}
      </button>
      <div
        class="absolute -bottom-px h-1 bg-white transition-all duration-300"
        :style="{
          left: `${indicatorLeft}px`,
          width: `${indicatorWidth}px`
        }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType } from 'vue'

interface Tab {
  value: string | number
  label: string
}

const props = defineProps({
  modelValue: {
    type: [String, Number],
    required: true
  },
  tabs: {
    type: Array as PropType<Tab[]>,
    default: () => []
  }
})

const emit = defineEmits(['update:modelValue'])

const tabRefs = ref<HTMLElement[]>([])
const indicatorLeft = ref(0)
const indicatorWidth = ref(0)

const updateIndicator = (index: number) => {
  if (tabRefs.value[index]) {
    const tab = tabRefs.value[index]
    indicatorLeft.value = tab.offsetLeft
    indicatorWidth.value = tab.offsetWidth
  }
}

const handleTabClick = (value: string | number, index: number) => {
  emit('update:modelValue', value)
  updateIndicator(index)
}

onMounted(() => {
  const activeIndex = props.tabs.findIndex((tab) => tab.value === props.modelValue)
  if (activeIndex > -1) {
    updateIndicator(activeIndex)
  }
})

watch(
  () => props.modelValue,
  (newValue) => {
    const activeIndex = props.tabs.findIndex((tab) => tab.value === newValue)
    if (activeIndex > -1) {
      updateIndicator(activeIndex)
    }
  }
)
</script>

<style scoped lang="scss"></style>
